import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Hashrouter, Switch, Route } from "react-router-dom";
// import Home from "./Pages/Home";
import Profile from "./Pages/Profile";
import Blog from "./Pages/Blog";
import Travel from "./Pages/Travel";
import TaxAdvisor from "./Pages/IncomeTaxAdvisor";
// import TaxAdvisor from "./Pages/TaxAdvisor";

import Photography from "./Pages/Photography/Photography";
import PhotoFeatured from "./Pages/Photography/PhotoFeatured";
import PhotoLandscape from "./Pages/Photography/PhotoLandscape";
import PhotoStreet from "./Pages/Photography/PhotoStreet";
import PhotoPortrait from "./Pages/Photography/PhotoPortrait";
import UploadPage from "./Pages/Admin/UploadPage";
import EditPhotos from "./Pages/Admin/EditPhotos";
import ReactGa from "react-ga";
import React, { useEffect, useState } from "react";
import PacmanLoader from "react-spinners/CircleLoader";

//ShresthaApps
import AboutPage from "./Pages/ShresthaApps/AboutPage";
import SharePage from "./Pages/ShresthaApps/SharePage";
import ShareIdPhotoApp from "./Pages/ShresthaApps/ShareIdPhotoApp";
import ShareMedsReminderApp from "./Pages/ShresthaApps/ShareMedsReminderApp";
import StoreRedirect from "./Pages/ShresthaApps/StoreRedirect";
import TermsPage from "./Pages/ShresthaApps/TermsPage";
import PrivacyPage from "./Pages/ShresthaApps/PrivacyPage";
import Privacy from "./Pages/MPC/Privacy";
import Share from "./Pages/MPC/Share";
import LiveScore from "./Pages/MPC/livescore";
import Transfer from "./Pages/MPC/transfer";
import LiveScoreV8 from "./Pages/MPC/LiveScorePageV8";
import LiveScoreV9 from "./Pages/MPC/LiveScorePageV9";
import Ads from "./Pages/ads";

function App() {
  const [loading, setLoading] = useState(true);
  setTimeout(() => {
    setLoading(false);
  }, 1000);

  useEffect(() => {
    ReactGa.initialize("UA-201315269-1");
    //to report page view
    ReactGa.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <>
      {loading ? (
        <div className="loading">
          <PacmanLoader color={"#FFFFFF"} loading={loading} size={50} />
        </div>
      ) : (
        <Hashrouter>
          <Switch>
            {/* <Route path="/" exact component={Home} /> */}
            <Route path="/" exact component={Profile} />
            {/* <Route path='/' exact component={AllPhotos} /> */}
            <Route path="/profile" component={Profile} />
            <Route path="/blog" component={Blog} />
            <Route path="/travel" component={Travel} />
            <Route path="/photography" component={Photography} />
            <Route path="/photofeatured" component={PhotoFeatured} />
            <Route path="/photolandscape" component={PhotoLandscape} />
            <Route path="/photostreet" component={PhotoStreet} />
            <Route path="/photoportrait" component={PhotoPortrait} />
            <Route path="/editphotos" exact component={EditPhotos} />
            <Route path="/uploadphotos" exact component={UploadPage} />
            <Route path="/taxadvisor" exact component={TaxAdvisor} />
            <Route path="/MPC/privacypolicy" exact component={Privacy} />
            <Route path="/MPC/share" exact component={Share} />
            <Route path="/mpc/stream" exact component={LiveScore} />
            <Route path="/MPC/stream" exact component={LiveScore} />
            <Route path="/MPC" exact component={LiveScore} />
            <Route path="/mpc/transfer" exact component={Transfer} />
            <Route path="/MPC/transfer" exact component={Transfer} />
            <Route path="/MPC/V8/" exact component={LiveScoreV8} />
            <Route path="/MPC/V9/" exact component={LiveScoreV9} />
            <Route path="/adspage" exact component={Ads} />
            <Route path="/sa/about" exact component={AboutPage} />
            <Route path="/sa/shareapp" exact component={SharePage} />
            <Route
              path="/sa/shareidphotoapp"
              exact
              component={ShareIdPhotoApp}
            />
            <Route
              path="/sa/sharemedsreminder"
              exact
              component={ShareMedsReminderApp}
            />
            <Route
              path="/sa/redirect"
              exact
              component={StoreRedirect}
            />
            <Route path="/sa/terms" component={TermsPage} />
            <Route path="/sa/privacy" component={PrivacyPage} />
          </Switch>
        </Hashrouter>
      )}
    </>
  );
}

export default App;
